import type { ReactElement } from 'react'
import { useNavigate } from 'react-router-dom'
import { AnchorCell } from 'app/components/table/AnchorCell'

/**
 * A row's name that opens its page, with the hover "Open" button the Locations table has. Routes
 * in-app on a plain click and opens a new tab on ctrl/cmd click, so `href` must be absolute: the
 * underlying <a> resolves a relative one against the URL. A `disabled` row (a location without
 * the product) shows its name without a link.
 */
export function OpenLinkCell({
  href,
  label,
  disabled,
}: {
  href: string
  label: string
  disabled?: boolean
}): ReactElement {
  const navigate = useNavigate()
  if (disabled) return <span className="px-2">{label}</span>
  return (
    <AnchorCell href={href} tooltipMessage={label} clickHandler={() => navigate(href)}>
      <span className="font-medium text-strong">{label}</span>
    </AnchorCell>
  )
}
